/* import __COLOCATED_TEMPLATE__ from './sqrt.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();